import { AuthIcon, BackgroundImage, Card } from "@aurem/components";
import type { ReactNode } from "react";
import { LanguageSelect } from "../LanguageSelect";

type Props = {
  platform: "admin" | "employee";
  children?: ReactNode;
};

export const AuthContainer = ({ platform, children }: Props) => {
  return (
    <BackgroundImage platform={platform}>
      <Card className="my-10 bg-white p-6 sm:p-8 md:p-12 rounded-3xl w-full max-w-[31.25rem] mx-auto gap-6 sm:gap-8 md:gap-10 flex flex-col shadow-[0_0_4px_0_rgba(196,196,199,1)]">
        <div className="flex justify-between gap-4">
          <AuthIcon />
          <LanguageSelect />
        </div>
        {children}
      </Card>
    </BackgroundImage>
  );
};
